import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { IonModal } from '@ionic/react'
import { format } from '@dt/fe-utils'
import { Icon, ProductImage } from '@cps'
import { storeMobx } from '@mobxStore'
import './index.scss'

interface IProps {
  data: IViewStore;
  reject?: any;
  resolve?: (type: string) => void;
}

/** 门店页弹窗 */
const StoreDetailModal: FC<IProps> = ({ data, reject, resolve }) => {
  const [defaultImg, setDefault] = useState<string>('')
  const [storeStyle, setStoreStyle] = useState({ width: 178, height: 100 })
  const storeSaleTime = format.toSaleTime(data.saleTime, bo === 'cn' ? '24' : '12')

  const getPicUrl = (store) => {
    const pics = format.toPic(store?.storeExtInfo?.storePic)
    setDefault(pics.url)
    calcStoreStyle(pics)
  }
  const calcStoreStyle = (pics) => {
    const imgWidth = window.innerWidth * 0.88
    const imgHeight = imgWidth / Number(pics.w || 178) * Number(pics.h || 100)
    setStoreStyle({ width: imgWidth, height: imgHeight })
  }

  const handleMenu = () => {
    resolve('menu')
  }

  useEffect(() => {
    getPicUrl(data)
  }, [data])
  return (
    <IonModal
      isOpen
      backdropDismiss
      onDidDismiss={reject}
      cssClass='store-display-detail-modal'
    >
      <div className='store-display-detail-modal-content'>
        <div className='back-wrap' onClick={reject}>
          <Icon name='BACK-12x' />
        </div>
        <div className='store-display-detail-modal-wrapper'>
          <div className='store-detail-wrapper' style={{ backgroundImage: `url(${require('@img/store/storeDetaillBg.png')})` }}>
            <div className='store-info-wrapper'>
              <div className='store-left-wrap'>
                <div className='bg-txt'>CITY</div>
                <div className='city'>{data.city.county}</div>
              </div>
              <div className='store-right-wrap'>
                <div className='c'>{data.storeName}</div>
                <div className='store-address'>{data.address}</div>
                <div className='store-sale-time'>{storeSaleTime.map((v, index: number) => <p key={index}>{v}</p>)}</div>
                <div className='store-tel'>{i18n.t('store.storeDisplayTel')}{data.tel}</div>
                <div className='brand-name'>{storeMobx.brand.brandName}</div>
              </div>
            </div>
            <div className='store-pic-wrapper'>
              {
                !defaultImg
                  ? (
                    <div className='empty-img'></div>
                  ) : (
                    <ProductImage
                      imgSrc={defaultImg}
                      width={storeStyle.width}
                      height={storeStyle.height}
                      className='waterfall-img'
                    />
                  )
              }
            </div>
          </div>
        </div>
        <div className='detail-btn' onClick={handleMenu}>{i18n.t('store.goMenu')}</div>
      </div>
    </IonModal>
  )
}

export default observer(StoreDetailModal)
